export default class BaseUploader {
  bucket = ''

  bizKey= ''

  keyPattern = undefined

  getToken = null

  postFile = null

  useAccelerate = false

  constructor({
    getToken,
    bucket,
    bizKey,
    keyPattern,
    postFile,
    useAccelerate,
  }) {
    if (!getToken || typeof getToken !== 'function') {
      throw new Error('[Uploader Exception]: Parameter `getToken` is necessary!')
    }
    this.bucket = bucket
    this.bizKey = bizKey
    this.keyPattern = keyPattern
    this.useAccelerate = useAccelerate
    this.getToken = getToken
    this.postFile = postFile
  }

  post(args) { } // eslint-disable-line

  multiPost({ files }) { } // eslint-disable-line
}
